package system

import com.github.quillraven.fleks.*
import com.github.quillraven.fleks.World.Companion.family
import com.github.quillraven.fleks.World.Companion.inject
import com.soywiz.korge.view.*
import component.*
import scenes.test.*

class PhysicDebugSystem(
    private val physicWorld: org.jbox2d.dynamics.World = inject(),
    private val sceneContainer: SContainer = inject(SCENE_CONTAINER)
): IteratingSystem(family{ all(PlayerComponent)}) {

    private var isInit = false
    private lateinit var debugText: Text

    override fun onTickEntity(entity: Entity) {
        val physicComp = entity[PhysicComponent]
        val playerComponent = entity[PlayerComponent]
        val stateComponent = entity[StateComponent]

        if (!isInit) {
            isInit = true
            debugText = sceneContainer.text("").position(2, 50)
        }

        debugText.text = """
            vx = ${physicComp.body.linearVelocity.x}
            vy = ${physicComp.body.linearVelocity.y}
            px = ${physicComp.body.position.x}
            py = ${physicComp.body.position.y}
            isGounded = ${playerComponent.playerMetadata.playerPhysicState.isGrounded}
            state = ${StateComponent.stateToText(stateComponent.state)}
        """.trimIndent()

        println("state = ${StateComponent.stateToText(stateComponent.state)}")
    }
}
